//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
let d=[[[0,"AdvancedSolutionObject",1,"Motion.AdvancedSolution",0],[0,"ReferenceObject",1,"Motion.IGraphSource",0],[0,"ReferencedCsys",1,"CoordinateSystem",0],[0,"ReferencedMarker",1,"Motion.Marker",0],[0,"SolutionObject",1,"Motion.MotionSolution",0],[0,"SourceObject",1,"TaggedObject",0]],[[["num","type_strings","value_strings"],"GetQuantityTypes",{},0,0],[["type_string","value_string"],"SetQuantityType",{},2,0],[[],"FindEquivalent",{R_:{pGraph:"Motion.Graph"}},0,0]],[]];
SPLM.Motion.GraphObjectBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.GraphObjectBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;